import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';
import scenery1_large from '../../img/scenery1_large.jpg'; 
import scenery1_medium from '../../img/scenery1_medium.jpg'; 
import scenery1_small from '../../img/scenery1_small.jpg'; 

const BeinnSgritheallDetails = () => {

  const dispatch = useDispatch();

  const navigateToActivity = () => {
    dispatch(setActivity(""));
  }

  return (
    <div className="row">
    <div className="col-12 imagesBackgroundColour">
        <div className="generalTextBox">
          <p className="activity-back-button">
            <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
          </p>
        </div>
    </div>
    <div className="col-12 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <h2 className="walks-section-heading">Beinn Sgritheall 973m</h2>
            <p className="walk-text">This is a fabulous day out and you need to make sure you have all of the equipment for a trip into the mountains including waterproofs, boots, 
                                      map and compass.  There are a number of options and I have given the simplest here which is an out and back starting from
                                      opposite Eilean Rarsaidh two miles back along the road to Glenelg.
            </p>      
            <h3 className="walks-detail-heading"><strong>Directions</strong></h3>
            <p className="walk-directions">1. Start from a small layby opposite Eilean Rarsaidh almost exactly two miles from the cottage back towards Glenelg.  There is room for a couple
                                      of cars.  The route starts at a cairn just this side of the parking spot.  If the car parking spot is used you may
                                      have to park a little further on just past the cattle grid and walk back to the start.
            </p>      
            <p className="walk-directions">2. Head up through young birch trees for about 30-40 minutes until you reach a plateau and a small lochan.
            </p>      
            <p className="walk-directions">3. Head right or East along a track.  It rises fairly steadily with plenty of stops to take in the view behind you
                                        out to Skye and the Small Isles or Rumm, Eigg, Canna and Muck. 
            </p>      
            <p className="walk-directions">4. The route ahead starts to look very steep and rocky but the track makes its way up with no difficulties
                                    and before you know it you are on the top of Beinn Sgritheall.  It has to be one of the best mountain viewpoints
                                    with the mix of mountains, sea lochs and islands.  Arnisdale can be seen in the distance far below.  Relax and take 
                                    it all in. 
            </p>      
            <p className="walk-directions">5. Retrace your steps not forgetting to turn left at the lochan and back down to your waiting car. 
            </p>      
            <h3 className="walks-detail-heading"><strong>Time</strong></h3>
            <p className="walk-text">5-8 hours depending how long you spend enjoying the views.
            </p>                                           
            <h3 className="walks-detail-heading"><strong>Alternatives</strong></h3>
            <p className="walk-text">Start in the village at the track just before the last house back towards Glenelg to make a circuit.  Steep
                                      sections over rocky ground just before the main summit plateau is reached may not be comfortable for some people. 
                                      
            </p>                                           
          </div>
        </div>
      </div>
      <div className="col-12 imagesBackgroundColour walk-image">
      <picture>
        <source srcSet={`${scenery1_small} 1x,${scenery1_medium} 2x`} media="(max-width: 600px)" />
        <img srcSet={`${scenery1_medium} 1x,${scenery1_large} 2x`}
          src={scenery1_medium} alt="View from Beinn Sgritheall" className="image"
        />
      </picture>
    </div>
    <div className="col-12 imagesBackgroundColour">
      <div className="generalText">
          <div className="generalTextBox">
            <p className="activity-back-button">
              <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
            </p>
          </div>
      </div>
    </div>
    </div>
  );
}

export default BeinnSgritheallDetails
